export default __webpack_public_path__ + "static/media/logo_einstein_horizontal_branco.7e8568c9.svg";